import { OpenLegacyViewFunction } from "src/components/views/legacy/hooks.ts";

export function openLegacyCustomerOrderView(
	openLegacyView: OpenLegacyViewFunction,
	customerOrderId: number,
) {
	openLegacyView("9e3e45c8-2825-4d57-8c33-eddec1c5b786-2", {
		_customer_order_id_filter: customerOrderId,
		_documents_locked: false,
	});
}

export function openLegacyCustomerOrderDeliveryView(
	openLegacyView: OpenLegacyViewFunction,
	customerOrderId: number,
	customerOrderDeliveryId: number,
) {
	openLegacyView("dacfe8c5-b910-4f3e-8d44-1b34e5d1d91d", {
		customer_order_id: customerOrderId,
		_customer_order_delivery_id_filter: customerOrderDeliveryId,
	});
}
